import { authenticatedFetch } from '../../services/authService';

/**
 * Create a new guess avatar room
 * @returns {Promise<{roomId: number}>}
 */
export const createGuessAvatarRoom = async (name, description) => {
  const response = await authenticatedFetch('/game/v1/room', 'POST', {
    "name": name,
    "description": description
  });
  return response?.room_id;
};

/**
 * Get room information
 * @param {string|number} roomId
 * @returns {Promise<{roomId: number, avatars: Array<Object>, round_number: number}>}
 */
export const getGuessAvatarRoom = async (roomId) => {
  const response = await authenticatedFetch(`/game/v1/room/${roomId}/round/latest`, 'GET');
  return response;
};

/**
 * Submit avatars for a room
 * @param {string|number} roomId
 * @param {Object} payload - {roomId, avatars: [{...DEFAULT_OPTS}, ...]}
 * @returns {Promise<{round_number:number}>}
 */
export const submitRoomAvatars = async (roomId, payload) => {
  const response = await authenticatedFetch(
    `/game/v1/room/${roomId}/round`,
    'POST',
    payload
  );
  return response;
};
